import React, { useState } from 'react';
import './ConfirmationModal.css';

function ConfirmationModal({ product, onConfirm, onCancel }) {
  const [quantity, setQuantity] = useState(1);

  if (!product) return null;

  const handleIncrement = () => {
    setQuantity(quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleConfirm = () => {
    onConfirm(quantity);
    setQuantity(1);
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onCancel}>✕</button>
        
        <div className="confirmation-content">
          <div className="confirmation-image">
            <img src={product.image} alt={product.title} />
          </div>

          <div className="confirmation-details">
            <h2>Add to Cart?</h2>
            
            <div className="product-info">
              <h3>{product.title}</h3>
              <p className="product-price">{product.priceDisplay}</p>
              {product.bestFor && (
                <p className="product-description">{product.bestFor}</p>
              )}
            </div>

            {/* Quantity Control */}
            <div className="quantity-control">
              <label>Quantity:</label>
              <div className="quantity-selector">
                <button 
                  className="qty-btn qty-minus"
                  onClick={handleDecrement}
                  disabled={quantity === 1}
                >
                  −
                </button>
                <input 
                  type="number" 
                  className="qty-input" 
                  value={quantity} 
                  onChange={(e) => {
                    const val = parseInt(e.target.value) || 1;
                    if (val >= 1) setQuantity(val);
                  }}
                  min="1"
                />
                <button 
                  className="qty-btn qty-plus"
                  onClick={handleIncrement}
                >
                  +
                </button>
              </div>
            </div>

            <div className="confirmation-actions">
              <button 
                className="btn-confirm-cancel"
                onClick={onCancel}
              >
                Cancel
              </button>
              <button 
                className="btn-confirm-add"
                onClick={handleConfirm}
              >
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
